<script>
    import Layout from "../../../layouts/main";
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";
    import Loader from "../../../../components/widgets/loader";
    import Forms from "../../../../mixins/Forms";

    import axios from 'axios';

    /**
     * View Twilio phone numbers component
     */
    export default {
        page: {
            title: "All Twilio Phone Numbers",
            meta: [{name: "description", content: appConfig.description}]
        },
        mixins: [Forms],
        components: {Layout, PageHeader, Loader},
        data() {
            return {
                title: "All Twilio Phone Numbers",
                items: [
                    {
                        text: "Settings",
                        href: "#"
                    },
                    {
                        text: "All Twilio Phone Numbers",
                        active: true
                    }
                ],

                isLoading: false,
                twilioPhoneNumbers: null,
                serverErrors: []
            };
        },
        methods: {
            loadTwilioPhoneNumbers() {
                let vm = this;
                vm.isLoading = true;

                vm.isSaving = true;
                axios.get(API_BASE + '/twilio-phone-numbers/').then(r => {
                    vm.isLoading = false;
                    vm.twilioPhoneNumbers = r.data;
                }).catch(e => {
                    console.log(e);
                    vm.isLoading = false;
                    vm.setErrors(e);
                });
            }
        },
        created() {
            this.loadTwilioPhoneNumbers();
        }
    };
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items"/>
        <errors :error-list="serverErrors"></errors>
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <div v-if="isLoading" class="text-center">
                            <b-spinner class="m-2" variant="itg-dark" role="status"></b-spinner>
                        </div>

                        <div v-if="!isLoading" class="table-responsive mb-0">
                            <table class="table mb-0 table-centered">
                                <thead class="thead-light">
                                <tr>
                                    <th>#</th>
                                    <th>Name</th>
                                    <th>Country Code</th>
                                    <th>Phone Number</th>
                                    <th>WhatsApp Enabled</th>
                                    <th></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="twilioPhoneNumber in twilioPhoneNumbers">
                                    <th scope="row">{{ twilioPhoneNumber.id }}</th>
                                    <td>{{ twilioPhoneNumber.name }}</td>
                                    <td>{{ twilioPhoneNumber.country_code }}</td>
                                    <td>{{ twilioPhoneNumber.phone_number }}</td>
                                    <td>
                                        <i v-if="twilioPhoneNumber.whatsapp_enabled" class="mdi mdi-check text-success"></i>
                                        <i v-else class="mdi mdi-close text-danger"></i>
                                    </td>
                                    <td class="text-right">
                                        <!-- Button trigger modal -->
                                        <button
                                                type="button"
                                                class="btn btn-itg btn-sm"
                                                @click="$router.push('/settings/twilio-phone-numbers/'+twilioPhoneNumber.id+'/edit')"
                                        >
                                            Edit
                                        </button>
                                    </td>
                                </tr>
                                <tr v-if="twilioPhoneNumbers.length === 0">
                                    <th scope="row" colspan="4">
                                        <span class="text-danger">No results</span>
                                    </th>
                                </tr>
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>

                <a href="#" class="btn btn-itg-dark"
                   @click.prevent="$router.push('/settings/twilio-phone-numbers/create')">Add
                    Phone Number
                </a>
            </div>
        </div>
        <!-- end row -->
    </Layout>
</template>
